import { Badge } from '../../Badge'

export type UsageBadgeProps = {
  usage: {
    provider: string
    model: string
    properties?: Record<string, string | number | boolean>
    amount: number
  }
}

export function UsageBadge (props: UsageBadgeProps) {
  const { usage } = props

  return (
    <Badge size="sm" color="neutral" outline>
      {usage.model}: {usage.amount} {getUnit(usage)}
    </Badge>
  )
}

function getUnit (usage: UsageBadgeProps['usage']): string {
  if (usage.properties?.token === 'input') {
    return 'input tokens'
  } else if (usage.properties?.token === 'output') {
    return 'output tokens'
  }

  return ''
}
